import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { DrawerInfoQuestionsForm } from '../../Drawers/DrawerInfoQuestionsForm/DrawerInfoQuestionsForm';
import images from '../../../../assets/images';
import ClickAwayListener from '@mui/material/ClickAwayListener';
export const BtnInfoIconQuestionForm = ({ infoModal }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        if (infoModal.type === "modal") {
            setOpen(true);
        }
    };
    const handleClose = () => setOpen(false);
    const [openTooltip, setOpenTooltip] = useState(false);
    const handleTooltipClose = () => {
        setOpenTooltip(false);
    };
    const handleTooltipOpen = () => {
        setOpenTooltip(true);
    };
    const button = (_jsx(IconButton, Object.assign({ className: 'btn-info-icon-question-form', "aria-label": "info", "data-testid": "info-button", size: "small", onClick: infoModal.type === "tooltip" ? handleTooltipOpen : handleOpen }, { children: _jsx("img", { src: images.info_contained, alt: "" }) })));
    return (_jsxs(_Fragment, { children: [infoModal.type === "tooltip" ? (_jsx(ClickAwayListener, Object.assign({ onClickAway: handleTooltipClose }, { children: _jsx(Tooltip, Object.assign({ title: _jsx(_Fragment, { children: infoModal.description.split('\n').map((line, idx) => (_jsx("p", { children: line }, idx))) }), placement: "top-start", leaveTouchDelay: 3000, onClose: handleTooltipClose, open: openTooltip, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, slotProps: {
                        popper: {
                            disablePortal: true,
                        },
                        tooltip: {
                            sx: {
                                fontSize: '0.875rem',
                                maxWidth: 300,
                            },
                        },
                    } }, { children: button })) }))) : (button), infoModal.type === "modal" && (_jsx(DrawerInfoQuestionsForm, { open: open, onClose: handleClose, title: infoModal.title, description: infoModal.description }))] }));
};
